var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 135,
    viewBox: "0 0 135 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.3203 17.9297H11.6016V105.469H83.3203V17.9297Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3203 17.9297H11.6016V105.469H83.3203V17.9297Z",
    stroke: "#242C88",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8047 48.5156H24.2578C23.0977 48.5156 22.1484 47.5664 22.1484 46.4062V35.8594C22.1484 34.6992 23.0977 33.75 24.2578 33.75H34.8047C35.9648 33.75 36.9141 34.6992 36.9141 35.8594V46.4062C36.9141 47.5664 35.9648 48.5156 34.8047 48.5156Z",
    fill: "#83D689"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5937 69.6094H24.2578C23.0977 69.6094 22.1484 68.6602 22.1484 67.5V56.9531C22.1484 55.793 23.0977 54.8438 24.2578 54.8438H34.8047C35.9648 54.8438 36.9141 55.793 36.9141 56.9531V67.2891C36.9141 68.5547 35.8594 69.6094 34.5937 69.6094Z",
    fill: "#83D689"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8047 91.7578H24.2578C23.0977 91.7578 22.1484 90.8086 22.1484 89.6484V79.1016C22.1484 77.9414 23.0977 76.9922 24.2578 76.9922H34.8047C35.9648 76.9922 36.9141 77.9414 36.9141 79.1016V89.6484C36.9141 90.8086 35.9648 91.7578 34.8047 91.7578Z",
    fill: "#83D689"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8047 48.5156H24.2578C23.0977 48.5156 22.1484 47.5664 22.1484 46.4062V35.8594C22.1484 34.6992 23.0977 33.75 24.2578 33.75H34.8047C35.9648 33.75 36.9141 34.6992 36.9141 35.8594V46.4062C36.9141 47.5664 35.9648 48.5156 34.8047 48.5156Z",
    stroke: "#242C88",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5937 69.6094H24.2578C23.0977 69.6094 22.1484 68.6602 22.1484 67.5V56.9531C22.1484 55.793 23.0977 54.8438 24.2578 54.8438H34.8047C35.9648 54.8438 36.9141 55.793 36.9141 56.9531V67.2891C36.9141 68.5547 35.8594 69.6094 34.5937 69.6094Z",
    stroke: "#242C88",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8047 91.7578H24.2578C23.0977 91.7578 22.1484 90.8086 22.1484 89.6484V79.1016C22.1484 77.9414 23.0977 76.9922 24.2578 76.9922H34.8047C35.9648 76.9922 36.9141 77.9414 36.9141 79.1016V89.6484C36.9141 90.8086 35.9648 91.7578 34.8047 91.7578Z",
    stroke: "#242C88",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M83.3203 106.523V25.3125H29.5312C28.3711 25.3125 27.4219 26.2617 27.4219 27.4219V106.523H83.3203Z",
    fill: "#242C88"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M104.414 30.5859H32.6953V118.125H104.414V30.5859Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.414 30.5859H32.6953V118.125H104.414V30.5859Z",
    stroke: "#242C88",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.4453 55.8984H79.1016",
    stroke: "#242C88",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.4453 50.625H91.7578",
    stroke: "#242C88",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9531 61.1719H46.4062C45.2461 61.1719 44.2969 60.2227 44.2969 59.0625V48.5156C44.2969 47.3555 45.2461 46.4062 46.4062 46.4062H56.9531C58.1133 46.4062 59.0625 47.3555 59.0625 48.5156V59.0625C59.0625 60.2227 58.1133 61.1719 56.9531 61.1719Z",
    fill: "#83D689"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7773 54.5273L50.8359 57.375L56.8477 51.2578",
    stroke: "#242C88",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.4453 78.0469H79.1016",
    stroke: "#242C88",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.4453 71.7188H91.7578",
    stroke: "#242C88",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9531 82.2656H46.4062C45.2461 82.2656 44.2969 81.3164 44.2969 80.1562V69.6094C44.2969 68.4492 45.2461 67.5 46.4062 67.5H56.7422C58.0078 67.5 59.0625 68.5547 59.0625 69.8203V80.1562C59.0625 81.3164 58.1133 82.2656 56.9531 82.2656Z",
    fill: "#83D689"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7773 75.832L50.8359 78.6797L56.8477 72.668",
    stroke: "#242C88",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.4453 99.1406H79.1016",
    stroke: "#242C88",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.4453 93.8672H91.7578",
    stroke: "#242C88",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9531 103.359H46.4062C45.2461 103.359 44.2969 102.41 44.2969 101.25V90.7031C44.2969 89.543 45.2461 88.5938 46.4062 88.5938H56.9531C58.1133 88.5938 59.0625 89.543 59.0625 90.7031V101.25C59.0625 102.41 58.1133 103.359 56.9531 103.359Z",
    fill: "#83D689"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9531 61.1719H46.4062C45.2461 61.1719 44.2969 60.2227 44.2969 59.0625V48.5156C44.2969 47.3555 45.2461 46.4062 46.4062 46.4062H56.9531C58.1133 46.4062 59.0625 47.3555 59.0625 48.5156V59.0625C59.0625 60.2227 58.1133 61.1719 56.9531 61.1719Z",
    stroke: "#242C88",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9531 82.2656H46.4062C45.2461 82.2656 44.2969 81.3164 44.2969 80.1562V69.6094C44.2969 68.4492 45.2461 67.5 46.4062 67.5H56.7422C58.0078 67.5 59.0625 68.5547 59.0625 69.8203V80.1562C59.0625 81.3164 58.1133 82.2656 56.9531 82.2656Z",
    stroke: "#242C88",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9531 103.359H46.4062C45.2461 103.359 44.2969 102.41 44.2969 101.25V90.7031C44.2969 89.543 45.2461 88.5938 46.4062 88.5938H56.9531C58.1133 88.5938 59.0625 89.543 59.0625 90.7031V101.25C59.0625 102.41 58.1133 103.359 56.9531 103.359Z",
    stroke: "#242C88",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M104.414 60.75L68.7656 81.7383L56.5312 100.09L78.4688 98.1914L104.414 82.8984V60.75Z",
    fill: "#242C88"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M117.492 52.8398L77.8359 92.4961L57.0586 99.7734L64.3359 78.9961L103.992 39.3398L117.492 52.8398Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M104.025 39.3923L64.3501 79.0673L77.8485 92.5657L117.523 52.8907L104.025 39.3923Z",
    fill: "#FFC408"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.538 48.9259L73.8628 88.6008L77.8154 92.5534L117.49 52.8785L113.538 48.9259Z",
    fill: "#242C88"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2227 90.7031L57.0586 99.5625L65.918 96.3984L60.2227 90.7031Z",
    fill: "#5E61A3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M117.492 52.8398L77.8359 92.4961L57.0586 99.7734L64.3359 78.9961L103.992 39.3398L117.492 52.8398Z",
    stroke: "#242C88",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M117.492 52.8398L123.82 46.5117C125.613 44.7187 125.613 41.8711 123.82 40.1836L116.648 33.0117C114.855 31.2188 112.008 31.2188 110.32 33.0117L103.992 39.3398L117.492 52.8398Z",
    fill: "#F3877E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M117.492 52.8398L123.82 46.5117C125.613 44.7187 125.613 41.8711 123.82 40.1836L116.648 33.0117C114.855 31.2188 112.008 31.2188 110.32 33.0117L103.992 39.3398L117.492 52.8398Z",
    stroke: "#242C88",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0078 77.4141L112.746 49.6758",
    stroke: "#242C88",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8281 88.5937L80.2617 82.1602",
    stroke: "#242C88",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M106.386 37.0781L100.868 42.5968L114.366 56.0952L119.885 50.5765L106.386 37.0781Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M106.386 37.0781L100.868 42.5968L114.366 56.0952L119.885 50.5765L106.386 37.0781Z",
    fill: "#242C88"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M106.386 37.0781L100.868 42.5968L114.366 56.0952L119.885 50.5765L106.386 37.0781Z",
    stroke: "#242C88",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/Notes.20ba2ab2995b158d7f032807e21ad16d.svg";
export { ForwardRef as ReactComponent };